import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ProcessedMedia from './processed-media-model'
import {
  CreateProcessedMediaAsync,
  DeleteProcessedMediaAsync,
  LoadProcessedMediasAsync,
} from './processedMedia-thunk'
const initialState: processedMediaSliceState = {
  processedMedia: [],
  selected_processedMedia: '',
  is_loading_processedMedia: false,
  is_creating_processedMedia: false,
  is_deleting_processedMedia: false,
}
export interface processedMediaSliceState {
  processedMedia: ProcessedMedia[]
  selected_processedMedia?: string
  is_loading_processedMedia: boolean
  is_creating_processedMedia: boolean
  is_deleting_processedMedia: boolean
}
export const processedMediaSlice = createSlice({
  name: 'processedMedia',
  initialState,
  reducers: {
    setSelectedprocessedMedia: (state, action) => {
      state.selected_processedMedia = action.payload
    },
    clearStateprocessedMedia: (state) => {
      state.processedMedia = []
      state.is_loading_processedMedia = false
      state.is_creating_processedMedia = false
      state.is_deleting_processedMedia = false
    },
    mergeprocessedMedia: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_processedMedia = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.processedMedia = merge(state.processedMedia, payload) as any
        }
      }
    },

    add_processedMedia: (state, action) => {
      if (action.payload) {
        state.processedMedia = [...state.processedMedia, action.payload]
      }
    },
    set_processedMedia: (state, action) => {
      let { key, value, id } = action.payload
      state.processedMedia = state.processedMedia.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProcessedMediasAsync.pending, (state) => {
      state.is_loading_processedMedia = true
    })
    builder.addCase(LoadProcessedMediasAsync.fulfilled, (state, action) => {
      state.is_loading_processedMedia = false
      if (action.payload) {
        state.processedMedia = action.payload
      }
    })
    builder.addCase(LoadProcessedMediasAsync.rejected, (state) => {
      state.is_loading_processedMedia = false
    })
    builder.addCase(CreateProcessedMediaAsync.pending, (state) => {
      state.is_creating_processedMedia = true
    })
    builder.addCase(CreateProcessedMediaAsync.fulfilled, (state) => {
      state.is_creating_processedMedia = false
    })
    builder.addCase(CreateProcessedMediaAsync.rejected, (state) => {
      state.is_creating_processedMedia = false
    })
    builder.addCase(DeleteProcessedMediaAsync.pending, (state) => {
      state.is_deleting_processedMedia = true
    })
    builder.addCase(DeleteProcessedMediaAsync.fulfilled, (state, action) => {
      state.is_deleting_processedMedia = false
      if (state.processedMedia) {
        state.processedMedia = state.processedMedia.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProcessedMediaAsync.rejected, (state) => {
      state.is_deleting_processedMedia = false
    })

    builder.addCase(
      autoThunks.get_processed_media_for_view.pending,
      (state) => {
        state.is_loading_processedMedia = true
      },
    )
    builder.addCase(
      autoThunks.get_processed_media_for_view.fulfilled,
      (state, action) => {
        state.is_loading_processedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_processed_media_for_view.rejected,
      (state) => {
        state.is_loading_processedMedia = false
      },
    )

    builder.addCase(autoThunks.load_processed_media.pending, (state) => {
      state.is_loading_processedMedia = true
    })
    builder.addCase(
      autoThunks.load_processed_media.fulfilled,
      (state, action) => {
        state.is_loading_processedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_processed_media.rejected, (state) => {
      state.is_loading_processedMedia = false
    })

    builder.addCase(autoThunks.get_all_media_resources.pending, (state) => {
      state.is_loading_processedMedia = true
    })
    builder.addCase(
      autoThunks.get_all_media_resources.fulfilled,
      (state, action) => {
        state.is_loading_processedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_all_media_resources.rejected, (state) => {
      state.is_loading_processedMedia = false
    })

    builder.addCase(autoThunks.get_media_to_watch.pending, (state) => {
      state.is_loading_processedMedia = true
    })
    builder.addCase(
      autoThunks.get_media_to_watch.fulfilled,
      (state, action) => {
        state.is_loading_processedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_media_to_watch.rejected, (state) => {
      state.is_loading_processedMedia = false
    })

    builder.addCase(autoThunks.get_next_processed_medias.pending, (state) => {
      state.is_loading_processedMedia = true
    })
    builder.addCase(
      autoThunks.get_next_processed_medias.fulfilled,
      (state, action) => {
        state.is_loading_processedMedia = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_next_processed_medias.rejected, (state) => {
      state.is_loading_processedMedia = false
    })
  },
})

function handleResult(action: any, state: processedMediaSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_processedMedia = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.processedMedia = merge(state.processedMedia, payload) as any
    }
  }
}

export const {
  clearStateprocessedMedia,
  setSelectedprocessedMedia,
  set_processedMedia,
  mergeprocessedMedia,
  add_processedMedia,
} = processedMediaSlice.actions

export const get_processedMedia =
  (id?: string) =>
  (state: {
    processedMedia: {
      processedMedia: ProcessedMedia[]
    }
  }): ProcessedMedia | null => {
    let temp = state?.processedMedia?.processedMedia?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.processedMedia?.processedMedia[0] || null
  }
export const get_selected_processedMedia = (state: {
  processedMedia: processedMediaSliceState
}): ProcessedMedia | null => {
  let id = state?.processedMedia?.selected_processedMedia
  let temp = state?.processedMedia?.processedMedia?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_processedMedia = (state: {
  processedMedia: {
    processedMedia: ProcessedMedia[]
  }
}): ProcessedMedia[] => {
  let temp = state?.processedMedia?.processedMedia
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_processedMedia_busy = (state: {
  processedMedia: processedMediaSliceState
}) => {
  return (
    state?.processedMedia.is_deleting_processedMedia ||
    state?.processedMedia.is_loading_processedMedia ||
    state?.processedMedia.is_creating_processedMedia
  )
}
export const is_deleting_processedMedia_busy = (state: {
  processedMedia: processedMediaSliceState
}) => {
  return state?.processedMedia.is_deleting_processedMedia
}
export const is_loading_processedMedia_busy = (state: {
  processedMedia: processedMediaSliceState
}) => {
  return state?.processedMedia.is_loading_processedMedia
}
export const is_creating_processedMedia_busy = (state: {
  processedMedia: processedMediaSliceState
}) => {
  return state?.processedMedia.is_creating_processedMedia
}

export default processedMediaSlice.reducer
